export default __webpack_public_path__ + "3bde69fdac2ea3c3762b56f702652fa3.svg";